<template>
  <ion-content id="app" class="ion-padding">
    <AddTag/>
    <ListTags/>
  </ion-content>
</template>

<script>
  import ListTags from ".././../components/tag/ListTags.vue";
  import AddTag from ".././../components/tag/AddTag.vue";
  import {mapActions} from "vuex";
  import 'core-js/es6/array';

  export default {
    name: "TagList",
    methods: {
      ...mapActions(["removeAllMessages"]),
    },
    components: {
      ListTags,
      AddTag,
    },
    created() {
      this.removeAllMessages();
    }
  };
</script>

<style>

</style>
